<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        Reactivate your Membership
      </content-page-title>
    </template>

    <v-btn-toggle
      v-model="existing"
      mandatory
      color="primary"
      background-color="white"
    >
      <v-btn small class="px-2" :value="false">Add a New Card</v-btn>
      <v-btn small class="px-2" :value="true">Use an Existing Card</v-btn>
    </v-btn-toggle>

    <Section class="mt-2">
      <WithExisting v-if="existing" @error="onError"/>
      <WithNew v-else />
    </Section>

    <ErrorOverlay
      title="Payment Error" v-model="error_dialog"
      :loading="false" :message="error_message"
    />
  </ContentPage>
</template>

<script>
import { ContentPage, ContentPageTitle, ErrorOverlay, Section } from '@/components/pages'
import WithExisting from './WithExisting'
import WithNew from './WithNew'

export default {
  name: 'BillingNewPaymentMethodView',

  components: { ContentPage, ContentPageTitle, ErrorOverlay, Section, WithExisting, WithNew },

  data: () => ({
    existing: false,

    error_dialog: false,
    error_message: '',
  }),

  methods: {
    onError(message) {
      this.error_dialog = true
      this.error_message = message
    },
  },
}
</script>